// YESWOOD_SEARCH_FIX_V2: Shopify treats unquoted words as a loose match and pads results up to its
// 1000 cap with unrelated products (price sort lists those first). Quoted words must all match and
// still rank by relevance, so plain input becomes quoted terms. Titles are indexed in Chinese only,
// so English words map to their Chinese terms; a word we cannot map stays a loose search.
const YESWOOD_TERMS = '现代简约 意式轻奢 新中式 奶油风 黑胡桃 胡桃色 胡桃 樱桃 白橡 红橡 橡木 白蜡 水曲柳 山毛榉 榉木 松木 桦木 楠木 枫木 鸡翅木 橡胶木 实木 原木 真皮 皮艺 布艺 岩板 藤编 中古 轻奢 北欧 日式 法式 美式 黑标 儿童 小户型 白色 黑色 床头柜 床垫 床尾凳 沙发床 沙发 餐边柜 餐桌 餐椅 茶几 边几 边柜 边桌 电视柜 书桌 书柜 书架 衣柜 斗柜 鞋柜 玄关柜 储物柜 收纳柜 展示柜 梳妆台 化妆台 化妆桌 梳妆凳 化妆凳 办公桌 学习桌 电脑桌 升降桌 办公椅 休闲椅 置物架 衣帽架 换鞋凳 长凳 堆叠凳 坐墩 脚凳 台灯 落地灯 吊灯 床 桌 椅 柜 凳 架 灯'.split(' ').sort((a, b) => b.length - a.length);
const YESWOOD_TERM_ALIASES = {'黑胡桃木': '黑胡桃', '胡桃木': '胡桃', '樱桃木': '樱桃', '白橡木': '白橡', '红橡木': '红橡', '白蜡木': '白蜡'};
const YESWOOD_ENGLISH_TERMS = {
  'solid wood': '实木', 'black walnut': '黑胡桃', walnut: '黑胡桃', oak: '橡木', cherry: '樱桃', ash: '白蜡', beech: '山毛榉', wood: '实木', wooden: '实木', leather: ['真皮', '皮艺'], fabric: '布艺', rattan: '藤编',
  sofa: '沙发', couch: '沙发', loveseat: '沙发', 'sofa bed': '沙发床', bed: '床', mattress: '床垫', nightstand: '床头柜', 'bedside table': '床头柜', 'dining table': '餐桌', 'dining chair': '餐椅', 'coffee table': '茶几', 'side table': ['边几', '边桌'], 'end table': ['边几', '边桌'], 'tv stand': '电视柜', 'tv cabinet': '电视柜', sideboard: '餐边柜', buffet: '餐边柜', desk: ['书桌', '办公桌', '学习桌', '电脑桌'], bookcase: ['书柜', '书架'], bookshelf: ['书柜', '书架'], wardrobe: '衣柜', dresser: '斗柜', vanity: ['梳妆', '化妆'], 'shoe cabinet': '鞋柜', 'shoe bench': '换鞋凳', bench: '凳', stool: '凳', ottoman: ['坐墩', '脚凳'], table: '桌', chair: '椅', cabinet: '柜', shelf: '架', rack: '架', lamp: '灯',
  kids: '儿童', modern: '现代', white: '白色', black: '黑色'
};
const YESWOOD_ENGLISH_STOP = ['a', 'an', 'and', 'for', 'in', 'of', 'the', 'with'];
const yeswoodQuote = term => {
  // A bare 床 would also match 床头柜 and 床垫.
  if (term === '床') return '"床" -"床头柜" -"床垫" -"床尾凳" -"床边"';
  return `"${term}"`;
};
function yeswoodChineseTerms(run) {
  if (YESWOOD_TERM_ALIASES[run]) return [YESWOOD_TERM_ALIASES[run]];
  const normalized = Object.keys(YESWOOD_TERM_ALIASES).reduce((text, key) => text.split(key).join(YESWOOD_TERM_ALIASES[key]), run);
  const terms = [];
  let unknown = '';
  for (let index = 0; index < normalized.length;) {
    const term = YESWOOD_TERMS.find(candidate => normalized.startsWith(candidate, index));
    if (!term) { unknown += normalized[index++]; continue; }
    if (unknown) { terms.push(unknown); unknown = ''; }
    terms.push(term); index += term.length;
  }
  if (unknown) terms.push(unknown);
  // A stray single character is not a meaningful word, so match the whole input as a phrase.
  const known = term => YESWOOD_TERMS.includes(term);
  return terms.some(term => term.length === 1 && !known(term)) ? [normalized] : terms;
}
function yeswoodSearchQuery(value) {
  const raw = String(value == null ? '' : value).trim();
  // Field syntax, quotes and parentheses mean the query is already explicit.
  if (!raw || /\b[a-z_][a-z_.]*:|["“”()]/i.test(raw)) return raw;
  const words = raw.replace(/[+＋,，、;；&|／]+/g, ' ').split(/\s+/).filter(word => word && word !== 'AND');
  // SKUs and item numbers only match unquoted.
  if (words.every(word => /^[a-z0-9][a-z0-9._-]*$/i.test(word) && /\d/.test(word))) return words.join(' ');
  const clauses = [];
  for (let index = 0; index < words.length; index++) {
    let word = words[index];
    if (word === 'OR') { clauses.push('OR'); continue; }
    const excluded = /^[-－]./.test(word);
    if (excluded) word = word.slice(1);
    const add = term => clauses.push(excluded ? `-"${term}"` : yeswoodQuote(term));
    if (/[一-鿿]/.test(word)) { yeswoodChineseTerms(word).forEach(add); continue; }
    const lower = word.toLowerCase();
    if (YESWOOD_ENGLISH_STOP.includes(lower)) continue;
    const singular = term => term.replace(/(ch|sh|x)es$/, '$1').replace(/ies$/, 'y').replace(/s$/, '');
    const pair = index + 1 < words.length ? `${lower} ${singular(words[index + 1].toLowerCase())}` : '';
    let mapped = YESWOOD_ENGLISH_TERMS[pair];
    if (mapped) index++;
    else mapped = YESWOOD_ENGLISH_TERMS[lower] || YESWOOD_ENGLISH_TERMS[singular(lower)];
    if (!mapped) return raw;
    if (Array.isArray(mapped)) clauses.push(excluded ? mapped.map(term => `-"${term}"`).join(' ') : `(${mapped.map(term => `"${term}"`).join(' OR ')})`);
    else add(mapped);
  }
  return clauses.join(' ') || raw;
}
window.YeswoodSearchQuery = yeswoodSearchQuery;

class SearchForm extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="search"]');
    this.resetButton = this.querySelector('button[type="reset"]');

    if (this.input) {
      this.setProductOnlySearch();
      // FormData changes the submitted query without exposing syntax in the input.
      this.input.form.addEventListener('formdata', event => {
        const query = this.input.value.trim();
        event.formData.set('q', yeswoodSearchQuery(query));
        event.formData.set('yw_query', query);
      });
      this.input.form.addEventListener('reset', this.onFormReset.bind(this));
      // Wait for IME composition (e.g. pinyin) to finish before searching.
      this.isComposing = false;
      this.input.addEventListener('compositionstart', () => {
        this.isComposing = true;
      });
      this.input.addEventListener('compositionend', (event) => {
        this.isComposing = false;
        this.onChange(event);
      });
      this.input.addEventListener(
        'input',
        debounce((event) => {
          if (this.isComposing || event?.isComposing) return;
          this.onChange(event);
        }, 300).bind(this)
      );
    }
  }

  setProductOnlySearch() {
    const searchForm = this.input.form;
    if (!searchForm) return;

    let resourceTypeInput = searchForm.querySelector('input[name="type"]');
    if (!resourceTypeInput) {
      resourceTypeInput = document.createElement('input');
      resourceTypeInput.type = 'hidden';
      resourceTypeInput.name = 'type';
      searchForm.appendChild(resourceTypeInput);
    }
    resourceTypeInput.value = 'product';
  }

  toggleResetButton() {
    const resetIsHidden = this.resetButton.classList.contains('hidden');
    if (this.input.value.length > 0 && resetIsHidden) {
      this.resetButton.classList.remove('hidden');
    } else if (this.input.value.length === 0 && !resetIsHidden) {
      this.resetButton.classList.add('hidden');
    }
  }

  onChange() {
    this.toggleResetButton();
  }

  shouldResetForm() {
    return !document.querySelector('[aria-selected="true"] a');
  }

  onFormReset(event) {
    // Prevent default so the form reset doesn't set the value gotten from the url on page load
    event.preventDefault();
    // Don't reset if the user has selected an element on the predictive search dropdown
    if (this.shouldResetForm()) {
      this.input.value = '';
      this.input.focus();
      this.toggleResetButton();
    }
  }
}

if (!window.__yeswoodProductOnlyPredictiveSearch) {
  const originalFetch = window.fetch.bind(window);

  window.fetch = (input, init) => {
    const requestUrl = typeof input === 'string' ? input : input?.url;

    if (requestUrl && typeof routes !== 'undefined' && requestUrl.startsWith(routes.predictive_search_url)) {
      const url = new URL(requestUrl, window.location.origin);
      url.searchParams.set('resources[type]', 'product');

      if (input instanceof Request) {
        input = new Request(url.toString(), input);
      } else {
        input = url.toString();
      }
    }

    return originalFetch(input, init);
  };

  window.__yeswoodProductOnlyPredictiveSearch = true;
}

customElements.define('search-form', SearchForm);
